/**
 * Supabase client exports
 *
 * Use these to create Supabase clients in your app:
 * - Browser client for client components (localStorage-based)
 * - Browser cookie client for client components (cookie-based, works with SSR auth)
 * - Server client for server components/actions
 */

export { createClient as createBrowserClient, supabase } from './browser'
export {
  createClient as createBrowserCookieClient,
  supabase as supabaseCookieClient
} from './browser-cookie'